import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';
import { FontSize } from '../vendor/_rfs.mixin';
import { BorderLeftRadius, BorderRightRadius } from './_border-radius.mixin';

export class PaginationSize extends Mixin {
  style({ $ }, [paddingY, paddingX, fontSize, lineHeight, borderRadius]) {
    return css`
      .page-link {
        padding: ${paddingY} ${paddingX};
        ${new FontSize(fontSize).include($)};
        line-height: ${lineHeight};
      }

      .page-item {
        &:first-of-type {
          .page-link {
            ${new BorderLeftRadius(borderRadius).include($)};
          }
        }
        &:last-child {
          .page-link {
            ${new BorderRightRadius(borderRadius).include($)};
          }
        }
      }
    `;
  }
}
